import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/DailyDbosActionsCountPage.head';
import { DailyDbosActionsCountPage } from '@pages/DailyDbosActionsCountPage';

export const Route = createFileRoute('/daily-dbos-actions-count')({
  component: DailyDbosActionsCountPage,
  head: () => head,
});
